<!-- bulk-order.component.html ) -->
<mat-drawer-container
  class="example-container relative bg-white-color"
  [hasBackdrop]="true"
  style="height: calc(100%) !important"
>
  <mat-drawer-content class="relative">
    <div
      class="relative container mx-auto flex flex-col lg:flex-row h-full w-full"
      style="height: 100%"
    >
      <!-- Main Form Area -->
      <div
        class="w-full lg:w-[70%] xl:w-[80%] 2xl:lg:w-[85%] h-full pt-4 lg:pt-8"
      >
        <div class="pickup-selection">
          <form
            [formGroup]="this.form"
            (keydown.enter)="$event.preventDefault()"
          >
            <div
              @showHide
              *ngIf="!isDropoffAdded; else reviewMode"
              class="flex flex-col"
            >
              <!-- <h4 class="standard-heading md:mb-7 sm:mb-5 mb-3">Choose Your Pickup Location</h4>  -->
              <div class="flex items-start justify-between">
                <div
                  class="flex md:items-center sm:items-start items-start gap-2 md:mb-7 sm:mb-5 mb-3"
                >
                  <button
                    mat-icon-button
                    class="max-h-[24px]"
                    (click)="goBack()"
                  >
                    <mat-icon
                      class="mat-18 md:font-bold sm:font-semibold font-semibold text-orange-color"
                      >arrow_back</mat-icon
                    >
                  </button>
                  <h4 class="text-base sm:text-lg md:text-xl font-semibold">
                    {{ "Bulk Packages" }}
                  </h4>
                </div>

                <div
                  *ngIf="
                    this.orderDoc &&
                    this.form.get('pickupLocationAddress').value
                  "
                  (click)="resetOrderFlow()"
                  class="flex items-center text-orange-color gap-1 font-semibold text-base cursor-pointer"
                >
                  <mat-icon
                    matTooltip="Proceeding with this action will reset your current order data, and this action cannot be undone."
                    class="mat-18 !text-xl"
                    >info_outline</mat-icon
                  >
                  <div class="hover:underline">Reset Form</div>
                </div>
              </div>

              <mat-tab-group
                class="no-header-tabs"
                [(selectedIndex)]="currentStep"
              >
                <mat-tab>
                  <div class="w-full">
                    <h4
                      class="text-blue-theme-color text-[20px] font-semibold mb-[20px]"
                    >
                      Choose Your Pickup Location
                    </h4>

                    <div
                      class="text-[13px] font-medium sm:text-sm md:text-base !custom-dark-gray mb-3"
                    >
                      {{ tipText }}
                    </div>

                    <div class="row mb-2 !max-w-[575px]">
                      <label class="form-label">{{
                        this.headings.pickupLocation | titlecase
                      }}</label>
                      <mat-form-field
                        class="cursor-pointer"
                        appearance="fill"
                        (click)="onPickupLocation('pickup')"
                      >
                        <input
                          readonly
                          matInput
                          formControlName="pickupLocationAddress"
                          class="cursor-pointer placeholder:text-[#000000DE]"
                          placeholder="Tap to enter exact pickup location"
                        />
                        <mat-icon
                          matSuffix
                          class="material-icons text-orange-color"
                          >location_on</mat-icon
                        >
                      </mat-form-field>
                    </div>

                    <div @showHide>
                      <h4
                        class="standard-heading md:mb-7 sm:mb-5 mb-4"
                        (click)="onPrint()"
                      >
                        Select Delivery Method
                      </h4>
                      <div class="row mb-2">
                        <div
                          class="grid 2xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                        >
                          <ng-container
                            *ngFor="
                              let item of this.isDropoffAdded
                                ? this.deliveryMethodsFire
                                : this.deliveryMethods;
                              let i = index
                            "
                          >
                            <div
                              matRipple
                              (click)="
                                item?.isUnavailable
                                  ? null
                                  : onSelectdeliveryMethods(i)
                              "
                              [ngClass]="[
                                item.isSelected
                                  ? 'border-orange-color bg-orange-color/5'
                                  : 'border-[#D8DFE7] bg-transparent',
                                i === this.deliveryMethods.length - 1 &&
                                this.deliveryMethods.length % 2 !== 0
                                  ? 'col-span-2 md:col-span-1'
                                  : ''
                              ]"
                              class="relative delivery-method-card flex flex-col justify-between border rounded-xl p-4 min-h-[180px] w-full cursor-pointer transition-all"
                            >
                              <div class="flex justify-between items-start">
                                <!-- Title -->
                                <div
                                  class="font-bold sm:text-lg text-blue-theme-color mb-1"
                                >
                                  {{ item.title }}
                                </div>
                                <!-- Top-right corner tags and checkmark -->
                                <div
                                  class="absolute top-[40px] md:top-3 right-[10px] md:right-3 flex flex-col items-end gap-1 z-10"
                                >
                                  <ng-container *ngIf="item.isRecommended">
                                    <span
                                      class="tag tag-recommended text-nowrap"
                                      >Recommended</span
                                    >
                                  </ng-container>
                                  <ng-container *ngIf="item?.isUnavailable">
                                    <span
                                      class="tag tag-not-available text-nowrap"
                                      >Not available</span
                                    >
                                  </ng-container>
                                  <img
                                    *ngIf="item.isSelected"
                                    class="w-6 h-6"
                                    src="assets/images/icons/checkMark.svg"
                                    alt="Selected"
                                  />
                                </div>
                              </div>
                              <!-- Price Row -->
                              <!-- <div class="flex items-center gap-2 mb-1">
                                <span
                                  class="text-orange-color font-bold text-sm"
                                >
                                  {{ item.currency }} {{ item.grossTotal }}
                                </span>
                                <span
                                  *ngIf="item.totalCharges > item.grossTotal"
                                  class="text-dark-gray text-base line-through"
                                >
                                  {{ item.currency }} {{ item.totalCharges }}
                                </span>
                              </div> -->

                              <!-- Estimated Time -->
                              <!-- <div
                                class="text-blue-500 text-sm font-semibold mb-2"
                              >
                                {{ item.estimateTime }}
                              </div> -->

                              <!-- Illustration/Image -->
                              <div class="flex justify-end items-end flex-1">
                                <img
                                  [src]="item.icon"
                                  class="w-24 h-16 object-contain"
                                  alt="{{ item.title }}"
                                  style="max-width: 100px; max-height: 70px"
                                />
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <!-- phelnu trust check section  -->
                    <ng-container
                      *ngIf="this.orderDoc?.isPhlenutrustCheckEnabled == 1"
                    >
                      <div class="border border-[#D8DFE7] p-4 mt-6 rounded-md">
                        <div class="flex justify-between">
                          <div class="flex items-center">
                            <img
                              src="assets/images/bulkOrder/trustCheck.svg"
                              class="w-[28px]"
                              alt=""
                            />
                            <h3 class="text-primary font-bold ml-1 text-[18px]">
                              {{ "Phlenu TrustCheck For All Drops" }}
                            </h3>
                          </div>
                          <mat-slide-toggle
                            (change)="onPhlenutrustToggle($event)"
                            [(ngModel)]="isPhlenutrustCheckEnabled"
                            [ngModelOptions]="{ standalone: true }"
                          ></mat-slide-toggle>
                        </div>

                        <div class="pt-2 text-primary font-Inter-SemiBold">
                          <span
                            >Our delivery personnel will verify your item at
                            pickup to ensure accuracy and prevent fraud before
                            delivery.</span
                          >
                        </div>

                        <!-- <div class="pt-2 flex justify-between">
                      <h3 class="text-primary font-bold  text-[16px]">{{'TrustCheck Fee:'}}</h3>
                      <h3 class="text-orange-color font-bold  text-[18px]">
                          {{this.selectedDeliveryMethod.currency + ' ' +
                          this.orderDoc?.phlenuTrustCheckCommision}}</h3>
                  </div> -->
                      </div>
                    </ng-container>
                  </div>
                </mat-tab>

                <mat-tab>
                  <div class="w-full">
                    <div>
                      <ng-container
                        *ngIf="
                          this.isBusinessPartner &&
                          this.form.get('pickupLocationAddress').value
                        "
                      >
                        <div class="mb-6 flex justify-between items-center">
                          <div class="inline-flex items-start gap-2">
                            <img
                              src="assets/images/ui/CSV-icon.png"
                              class="w-6 aspect-square object-contain"
                              alt=""
                            />
                            <div>
                              <p
                                class="text-[16px] text-blue-theme-color font-semibold"
                              >
                                Upload Drop-off Locations
                              </p>
                              <p class="text-sm">
                                (Easily import multiple drop-off locations for
                                bulk deliveries via a csv file)
                              </p>
                            </div>
                          </div>
                          <div>
                            <button
                              mat-flat-button
                              color="primary"
                              class="bg-blue-theme-color gap-2 flex justify-center items-center !px-[30px] !h-11 text-white-color rounded-md"
                              (click)="openImportDropoffDialog()"
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                      </ng-container>

                      <h2
                        class="text-[20px] flex items-center gap-2 sm:mb-[15px] mb-[15px] font-bold text-blue-theme-color"
                      >
                        Add Drop-Off Location
                        <button
                          mat-icon-button
                          matRipple
                          (click)="
                            addDropRow(
                              this.dropoffLocations['controls'].length
                            );
                            $event.stopPropagation()
                          "
                          class="border bg-[#387DF4] border-none w-[30px] flex items-center justify-center aspect-square rounded-md"
                        >
                          <mat-icon class="mat-12 text-white-color"
                            >add</mat-icon
                          >
                        </button>
                      </h2>

                      <mat-tab-group
                        #tabGroup
                        mat-align-tabs="start"
                        [(selectedIndex)]="this.selectedIndex"
                        (selectedTabChange)="updateDropOff()"
                        class="dropLocationTabsGroup min-h-[200px] overflow-visible"
                        mat-align-tabs="start"
                      >
                        <ng-container
                          formArrayName="dropoffLocations"
                          *ngFor="
                            let dropoff of this.dropoffLocations['controls'];
                            let dropIndex = index
                          "
                        >
                          <mat-tab>
                            <ng-template
                              mat-tab-label
                              class="w-[48px] !overflow-visible relative"
                            >
                              <span
                                [ngClass]="{
                                  'tab-valid': dropoff.valid ? true : false,
                                  'invalid-and-touched':
                                    dropoff.touched && dropoff.invalid
                                      ? true
                                      : false
                                }"
                                >{{ dropIndex + 1 }}</span
                              >
                              <!-- <span *ngIf="!dropoff.valid"
                                >Drop-off {{ dropIndex + 1 }}</span
                              > -->
                              <!-- <mat-icon
                                *ngIf="dropoff.valid"
                                class="!mat-12 !rounded-full !p-1.5 !text-base text-white-color bg-green-color"
                                >done</mat-icon
                              > -->
                              <img
                                *ngIf="dropoff.valid"
                                class="absolute w-5.5 aspect-square top-[12px] right-[12px]"
                                src="assets/images/icons/checkMark.svg"
                                alt=""
                              />

                              <mat-icon
                                *ngIf="
                                  this.dropoffLocations['controls'].length >
                                  minDropoffCount
                                "
                                (click)="
                                  removeTab(dropIndex); $event.stopPropagation()
                                "
                                class="absolute right-[-8px] top-[-12px] z-10 text-orange-color bg-white-color w-fit rounded-full"
                                >cancel</mat-icon
                              >
                            </ng-template>

                            <div
                              class="flex flex-col sm:gap-[0px] gap-[0px] md:gap-[10px]"
                              [formGroup]="dropoff"
                            >
                              <div class="md:mt-2 sm:mt-4 mt-3 mb-5">
                                <div class="flex pl-3 gap-2 items-center">
                                  <mat-checkbox
                                    formControlName="isCashCollected"
                                    (change)="onCheckCashCollection(dropoff)"
                                    class="flex items-center checkWithIcon"
                                  >
                                    <span class="text-[15px] text-black-color"
                                      >Collect payment upon delivery of your
                                      sold items.</span
                                    >
                                  </mat-checkbox>
                                  <button
                                    mat-icon-button
                                    (click)="openInfoDialog()"
                                    class="flex items-center"
                                  >
                                    <mat-icon class="mat-18 text-dark-gray"
                                      >info_outline</mat-icon
                                    >
                                  </button>
                                </div>
                              </div>

                              <div
                                class="flex sm:flex-col flex-col md:flex-row md:gap-[35px] sm:gap-[0px] gap-[0px] max-w-[700px] md:mb-0 sm:mb-4 mb-4"
                              >
                                <div class="flex flex-col w-full">
                                  <label class="label font-medium">Name</label>
                                  <mat-form-field
                                    class="flex-1 form-field"
                                    appearance="fill"
                                  >
                                    <input
                                      formControlName="contactPerson"
                                      matInput
                                      class="mt-1"
                                      placeholder="Enter Receiver Name"
                                    />
                                    <mat-error>{{
                                      dropoff
                                        .get("contactPerson")
                                        .hasError("pattern")
                                        ? "Invalid Value"
                                        : dropoff
                                            .get("contactPerson")
                                            .hasError("required")
                                        ? "Receiver Name Required"
                                        : ""
                                    }}</mat-error>
                                  </mat-form-field>
                                </div>

                                <div
                                  class="md:h-[75px] sm:h-[75px] h-[75px] w-full"
                                >
                                  <div
                                    class="country-code-field flex-1 form-field"
                                    appearance="outline"
                                  >
                                    <label class="label mb-[1px] font-medium"
                                      >Contact Number</label
                                    >
                                    <div
                                      class="relative flex items-center border p-2.5 overflow-hidden border-[#D5D5D5] !rounded-md"
                                    >
                                      <div
                                        class="absolute flex h-full max-w-16 overflow-hidden w-16"
                                      >
                                        <mat-select
                                          appearance="outline"
                                          tabindex="-1"
                                          [disabled]="true"
                                          (selectionChange)="changeCountry()"
                                          class="!flex !items-center"
                                          (click)="$event.stopPropagation()"
                                          [(value)]="this.selectedCountryCode"
                                        >
                                          <mat-option
                                            *ngFor="
                                              let country of this.countries
                                            "
                                            [value]="country.code.toString()"
                                          >
                                            <div class="flex flex-row gap-1">
                                              <img
                                                class="w-6 aspect-square object-contain"
                                                [src]="country.logo"
                                                alt=""
                                              />
                                              <p>{{ country.code }}</p>
                                            </div>
                                          </mat-option>
                                        </mat-select>
                                      </div>
                                      <input
                                        (click)="$event.stopPropagation()"
                                        [maxlength]="
                                          this.selectedCountryCode == '+233'
                                            ? this.checkZeroNumber(
                                                this.dropoff.get('personNumber')
                                                  ?.value,
                                                dropIndex
                                              )
                                              ? '10'
                                              : '9'
                                            : this.checkZeroNumber(
                                                this.dropoff.get('personNumber')
                                                  ?.value,
                                                dropIndex
                                              )
                                            ? '11'
                                            : '10'
                                        "
                                        formControlName="personNumber"
                                        matInput
                                        style="padding-left: 75px !important"
                                        class="flex-1"
                                        placeholder="Enter Mobile Number"
                                        type="text"
                                        appNoSpaces
                                      />
                                    </div>
                                    <div class="flex flex-col">
                                      <span
                                        class="text-red text-xs font-medium mt-1"
                                        *ngIf="
                                          this.dropoff
                                            .get('personNumber')
                                            .hasError('pattern')
                                        "
                                        >Invalid number</span
                                      >
                                      <span
                                        class="text-red text-xs font-medium mt-1"
                                        *ngIf="
                                          this.dropoff.get('personNumber')
                                            .touched &&
                                          this.dropoff
                                            .get('personNumber')
                                            .hasError('required')
                                        "
                                        >Mobile number is required</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                @showHide
                                *ngIf="dropoff.get('isCashCollected').value"
                                class="w-full flex flex-col"
                              >
                                <label class="label font-medium"
                                  >Cash Collection Amount</label
                                >
                                <mat-form-field
                                  class="md:w-[460px] sm:w-full w-full form-field"
                                  appearance="fill"
                                >
                                  <input
                                    formControlName="collectCash"
                                    [required]="
                                      dropoff.get('isCashCollected').value
                                    "
                                    type="number"
                                    matInput
                                    class="mt-0"
                                    min="1"
                                    placeholder="Enter the Cash Collection Amount"
                                    (keydown)="preventInvalidKeys($event)"
                                  />
                                  <mat-error
                                    *ngIf="
                                      dropoff
                                        .get('collectCash')
                                        ?.hasError('min')
                                    "
                                  >
                                    Please enter valid amount
                                  </mat-error>
                                  <mat-error
                                    >Cash collection amount is
                                    required</mat-error
                                  >
                                  <mat-error
                                    *ngIf="
                                      form
                                        .get('collectCash')
                                        ?.hasError('pattern')
                                    "
                                  >
                                    Enter a valid positive number
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div class="row mb-4">
                                <label class="form-label"
                                  >Dropoff Location</label
                                >
                                <mat-form-field
                                  (click)="selectDropOff(dropIndex)"
                                  class="cursor-pointer focus:outline-none"
                                  appearance="fill"
                                >
                                  <input
                                    tabindex="0"
                                    readonly
                                    matInput
                                    formControlName="dropoffPointAddress"
                                    class="cursor-pointer focus:outline-none placeholder:text-[#000000DE]"
                                    placeholder="Tap to enter exact dropoff location"
                                  />
                                  <mat-icon
                                    matSuffix
                                    class="material-icons text-orange-color"
                                    >location_on</mat-icon
                                  >
                                  <!-- <mat-error *ngIf="this.form.get('pickupLocationAddress').value && this.form.get('pickupLocationAddress').touched">Pickup Location </mat-error> -->
                                </mat-form-field>
                              </div>

                              <div
                                class="text-[13px] font-medium sm:text-sm md:text-base !custom-dark-gray mb-3"
                              >
                                {{ tipText }}
                              </div>

                              <div>
                                <label class="form-label"
                                  >What Are We handling?</label
                                >
                                <div class="row mt-4 mb-4">
                                  <div
                                    class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                                  >
                                    <ng-container
                                      *ngFor="
                                        let item of dropoff.get('handlingItems')
                                          .value;
                                        let i = index
                                      "
                                    >
                                      <div
                                        matRipple
                                        (click)="
                                          selectHandlingMethods(i, dropIndex)
                                        "
                                        [ngClass]="
                                          item.isSelected
                                            ? 'border-orange-color bg-orange-color/5'
                                            : 'border-gray-color '
                                        "
                                        class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative flex md:flex-row sm:justify-start sm:flex-row flex-col cursor-pointer border items-center rounded-lg sm:gap-3 gap-1"
                                      >
                                        <img
                                          draggable="false"
                                          [src]="item.icon"
                                          class="w-[42px] aspect-square"
                                          alt=""
                                        />
                                        <span
                                          class="text-base text-blue-theme-color sm:text-left text-center font-semibold"
                                          >{{ item.title | titlecase }}</span
                                        >
                                        <img
                                          *ngIf="item.isSelected"
                                          class="absolute w-5 aspect-square top-2 right-2"
                                          src="assets/images/icons/checkMark.svg"
                                          alt=""
                                        />
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>

                              <div
                                @showHide
                                *ngIf="
                                  dropoff.get('handlingSubItems').value?.length
                                "
                              >
                                <div class="row mb-2">
                                  <div
                                    class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                                  >
                                    <ng-container
                                      *ngFor="
                                        let item of dropoff.get(
                                          'handlingSubItems'
                                        ).value;
                                        let i = index
                                      "
                                    >
                                      <div
                                        (click)="
                                          onSelectPackagedItem(i, dropIndex)
                                        "
                                        [ngClass]="
                                          item.isSelected
                                            ? 'border-orange-color bg-orange-color/5'
                                            : 'border-[#D8DFE7] '
                                        "
                                        matRipple
                                        class="rounded-lg border relative cursor-pointer flex sm:flex-row flex-col items-center gap-2 px-4 md:py-4 sm:py-3 py-3"
                                      >
                                        <img
                                          [src]="item.images"
                                          onerror="this.onerror = null; this.src='assets/images/icons/other.png'"
                                          draggable="false"
                                          class="w-[33px] aspect-square"
                                          alt=""
                                        />
                                        <span
                                          class="text-blue-theme-color sm:text-left sm:leading-5 leading-4 text-center text-base font-medium break-all md:pr-4 sm:pr-0 pr-0"
                                          >{{ item.title | titlecase }}</span
                                        >
                                        <img
                                          *ngIf="item.isSelected"
                                          class="absolute w-5 aspect-square top-2 right-2"
                                          src="assets/images/icons/checkMark.svg"
                                          alt=""
                                        />
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                              <!-- 
                                                    <p class="text-lg text-black-color">{{dropoff.get('selectedSubItem').value?.id}}</p> 
                                                    <p class="text-lg text-black-color">{{dropoff.get('attachmentUrl')?.value}}</p> 
                                                    <p class="text-lg text-black-color">{{dropoff.get('isAttachmentUploaded')?.value}}</p>  -->

                              <div
                                @showHide
                                *ngIf="
                                  dropoff.get('selectedSubItem').value?.id == 0
                                "
                                class="row md:w-[296px] mt-8 w-full sm:w-full mb-2"
                              >
                                <mat-form-field appearance="fill" class="pr-0">
                                  <input
                                    formControlName="attachmentInfo"
                                    matInput
                                    placeholder="Enter the detail..."
                                  />
                                  <button
                                    mat-icon-button
                                    *ngIf="
                                      !this.dropoff.get('attachment').dirty &&
                                      !dropoff.get('attachmentUrl')?.value
                                    "
                                    (click)="itemAttachment.click()"
                                    matTooltip="Attach Image"
                                    matRipple
                                    class="w-[40px] aspect-square flex items-center justify-center rounded-full"
                                  >
                                    <mat-icon
                                      class="mat-18 text-blue-theme-color"
                                      >attach_file</mat-icon
                                    >
                                  </button>
                                  <mat-progress-spinner
                                    *ngIf="this.dropoff.get('attachment').dirty"
                                    class="imageUpload pr-6"
                                    [diameter]="24"
                                    [mode]="'indeterminate'"
                                  ></mat-progress-spinner>
                                  <input
                                    type="file"
                                    class="invisible w-0 h-0"
                                    (change)="
                                      onAttachmentSelect($event, dropIndex)
                                    "
                                    formControlName="attachment"
                                    #itemAttachment
                                    accept="image/png, image/gif, image/jpeg"
                                  />
                                </mat-form-field>
                              </div>

                              <div
                                @showHide
                                *ngIf="
                                  dropoff.get('selectedSubItem')?.value?.id ==
                                    0 && dropoff.get('attachmentUrl')?.value
                                "
                              >
                                <div class="w-52 aspect-video relative">
                                  <img
                                    [src]="dropoff.get('attachmentUrl')?.value"
                                    class="w-full h-full object-cover"
                                    alt=""
                                  />
                                  <button
                                    (click)="onRemoveAttachment(dropIndex)"
                                    mat-icon-button
                                    matRipple
                                    class="absolute w-[40px] aspect-square flex items-center justify-center rounded-full top-0 right-0"
                                  >
                                    <mat-icon class="mat-18 text-orange-color"
                                      >close</mat-icon
                                    >
                                  </button>
                                </div>
                              </div>

                              <div>
                                <label class="form-label"
                                  >Choose Your Package size</label
                                >
                                <div class="row mt-4 mb-4">
                                  <div
                                    class="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-5 gap-[14px]"
                                  >
                                    <ng-container
                                      *ngFor="
                                        let item of dropoff.get('packageSizes')
                                          .value;
                                        let i = index
                                      "
                                    >
                                      <div
                                        (click)="
                                          onSelectDropPacksize(i, dropIndex)
                                        "
                                        matRipple
                                        [ngClass]="[
                                          item?.isSelected
                                            ? 'border-orange-color bg-orange-color/5'
                                            : 'border-gray-color   bg-slaty-color',
                                          i ===
                                            dropoff.get('packageSizes').value
                                              .length -
                                              1 &&
                                          dropoff.get('packageSizes').value
                                            .length %
                                            2 !==
                                            0
                                            ? 'col-span-2 md:col-span-1'
                                            : ''
                                        ]"
                                        class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative cursor-pointer border-2 items-center bg-white rounded-lg flex flex-col justify-between"
                                      >
                                        <div
                                          class="flex-1 flex flex-col mr-auto"
                                        >
                                          <span
                                            class="md:text-lg sm:text-base text-base text-blue-theme-color font-semibold"
                                            >{{ item.name }}</span
                                          >
                                          <span
                                            class="text-[13px] text-[#7C8390] font-Inter-Medium font-medium"
                                            >{{ item.info | titlecase }}</span
                                          >
                                        </div>
                                        <img
                                          draggable="false"
                                          [src]="item.icon"
                                          class="w-[50px] rounded-lg object-contain aspect-square ml-auto"
                                          alt=""
                                        />
                                        <img
                                          *ngIf="item.isSelected"
                                          class="absolute w-5 aspect-square top-2 right-2"
                                          src="assets/images/icons/checkMark.svg"
                                          alt=""
                                        />
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>

                              <ng-container
                                *ngIf="
                                  this.orderDoc?.isPhlenutrustCheckEnabled == 1
                                "
                              >
                                <div
                                  class="border border-[#D8DFE7] p-4 rounded-md"
                                >
                                  <div class="flex justify-between">
                                    <div class="flex items-center">
                                      <img
                                        src="assets/images/bulkOrder/trustCheck.svg"
                                        class="w-[28px]"
                                        alt=""
                                      />
                                      <h3
                                        class="text-blue-theme-color font-bold ml-1 text-[18px]"
                                      >
                                        {{ "Phlenu TrustCheck" }}
                                      </h3>
                                    </div>
                                    <mat-slide-toggle
                                      (change)="
                                        onPhlenutrustDropToggle(
                                          $event,
                                          dropIndex
                                        )
                                      "
                                      formControlName="isPhlenuTrustCheckApplied"
                                    >
                                    </mat-slide-toggle>
                                  </div>

                                  <div
                                    class="pt-2 text-primary font-Inter-SemiBold"
                                  >
                                    <span
                                      >Our delivery personnel will verify your
                                      item at pickup to ensure accuracy and
                                      prevent fraud before delivery.</span
                                    >
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </mat-tab>
                        </ng-container>
                      </mat-tab-group>

                      <!-- tab action -->
                      <div
                        class="flex pb-6 border-b-2 border-gray-color justify-between items-center"
                      >
                        <div *ngIf="this.selectedIndex == 0"></div>
                        <button
                          mat-fab
                          (click)="onPre()"
                          *ngIf="this.selectedIndex != 0"
                          matRipple
                          class="text-orange-color flex items-center py-1 px-3 gap-2 md:text-lg sm:text-base text-base"
                        >
                          <mat-icon class="mat-18">west</mat-icon> Previous
                          Location
                        </button>

                        <button
                          *ngIf="
                            this.selectedIndex !=
                            this.dropoffLocations['controls'].length - 1
                          "
                          mat-fab
                          (click)="onNext()"
                          matRipple
                          class="text-orange-color flex items-center py-1 px-3 gap-2 md:text-lg sm:text-base text-base"
                        >
                          Next Location <mat-icon class="mat-18">east</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>

              <div class="flex gap-4 justify-between py-6">
                <button
                  *ngIf="currentStep !== 0"
                  color="primary"
                  (click)="goToPreviousStep()"
                  class="border-blue-theme-color gap-2 flex justify-center items-center !px-8 !h-12 text-blue-theme-color border rounded-md"
                  mat-flat-button
                >
                  <mat-icon>arrow_back</mat-icon>
                  Previous
                </button>

                <!-- <button
                  mat-stroked-button
                  color="primary"
                  (click)="goNext()"
                  [disabled]="currentStep === maxStep"
                >
                  Next
                  <mat-icon>arrow_forward</mat-icon>
                </button> -->

                <button
                  *ngIf="currentStep !== maxStep"
                  color="primary"
                  (click)="goNext()"
                  class="bg-blue-theme-color gap-2 flex justify-center items-center !px-8 !h-12 text-white-color rounded-md"
                  mat-flat-button
                >
                  Next
                  <mat-icon>arrow_forward</mat-icon>
                </button>

                <div class="" *ngIf="currentStep">
                  <button
                    color="primary"
                    (click)="onReview()"
                    [ngClass]="
                      this.form.invalid ? 'opacity-[0.8]' : 'opacity-100'
                    "
                    class="bg-blue-theme-color flex justify-center items-center !px-8 !h-12 text-white-color !rounded-md"
                    mat-flat-button
                  >
                    <span>Review</span>
                  </button>
                </div>
              </div>
            </div>

            <ng-template #reviewMode>
              <div
                @showHide
                class="flex md:gap-[20px] sm:gap-[45px] gap-[35px] flex-col mb-5"
              >
                <div class="flex flex-col md:gap-[32px] sm:gap-[20] gap-[20px]">
                  <div
                    class="flex justify-between md:flex-row sm:flex-col flex-col md:items-center sm:items-start items-start"
                  >
                    <h4 class="standard-heading">Review Your Bulk Order</h4>
                    <button
                      mat-fab
                      (click)="this.isDropoffAdded = false"
                      matRipple
                      class="text-orange-color flex items-center py-1 px-3 gap-2 text-base"
                    >
                      <mat-icon class="mat-18">edit</mat-icon>Edit Bulk
                      Locations
                    </button>
                  </div>

                  <div
                    class="border border-[#D8DFE7] max-w-2xl p-4 rounded-[12px]"
                  >
                    <label class="form-label">{{
                      this.headings.pickupLocation | titlecase
                    }}</label>
                    <div class="flex mt-2 gap-1 items-center">
                      <span class="bulk-info">{{
                        this.form.get("pickupLocationAddress").value | titlecase
                      }}</span>
                    </div>
                  </div>

                  <div @showHide>
                    <label class="form-label block !mb-2"
                      >Dropoff Locations</label
                    >
                    <div
                      class="max-h-[600px] border border-[#D8DFE7] p-4 max-w-2xl rounded-[12px] overflow-hidden overflow-y-auto"
                    >
                      <ng-container
                        *ngFor="
                          let group of this.dropoffLocations['controls'];
                          let gpIndex = index
                        "
                      >
                        <div
                          class="drop-point"
                          *ngIf="group.get('contactPerson').value"
                          [ngClass]="
                            this.dropoffLocations['controls'][gpIndex + 1]?.get(
                              'contactPerson'
                            )?.value &&
                            gpIndex !=
                              this.dropoffLocations['controls'].length - 1
                              ? 'sideDashedBorder'
                              : ''
                          "
                        >
                          <span class="drop-index text-orange-color"
                            >Dropoff location {{ gpIndex + 1 }}</span
                          >
                          <p class="drop-person-name !text-[#0B1640]">
                            {{ group.get("contactPerson").value | titlecase }}
                            <span
                              *ngIf="
                                group.get('isPhlenuTrustCheckApplied')?.value
                              "
                              class="inline-flex items-center gap-1 bg-[#ddf5db] text-green-color text-[12px] font-medium px-3 py-1 rounded-full"
                              >🛡️ Verified</span
                            >
                          </p>

                          <span class="drop-person-number"
                            ><a
                              [href]="
                                'tel:' +
                                group.get('dropoffPoint').value.dialCode +
                                '' +
                                this.phoneNumberTrimPickup(
                                  group.get('personNumber').value
                                )
                              "
                              ><mat-icon
                                class="text-black-color !text-[17px] align-middle"
                                >call</mat-icon
                              >{{ group.get("dropoffPoint").value.dialCode }}
                              {{ group.get("personNumber").value }}</a
                            ></span
                          >

                          <span class="bulk-info !text-sm">{{
                            group.get("dropoffPointAddress").value | titlecase
                          }}</span>

                          <span class="drop-index"
                            ><span>Package Size:</span>
                            <strong>
                              {{ group.get("packageSize").value?.name }}
                            </strong></span
                          >

                          <span class="drop-index"
                            ><span>Handling Item:</span>
                            {{
                              group.get("selectedSubItem").value?.id == 0
                                ? group.get("attachmentInfo").value
                                : group.get("selectedSubItem").value?.title
                            }}</span
                          >

                          <span
                            *ngIf="group.get('collectCash').value"
                            class="drop-index"
                            ><span class="">Cash Collection Amount: </span>
                            <strong>{{
                              group.get("collectCash").value
                            }}</strong></span
                          >
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex gap-[35px] flex-col">
                <!-- Schedule Delivery -->
                <div>
                  <label
                    class="text-[20px] font-semibold text-blue-theme-color !mb-4 block"
                    >Schedule Delivery
                  </label>
                  <mat-slide-toggle formControlName="isScheduleDelivery">
                    <span
                      class="sm:text-lg text-base text-blue-theme-color mb-2 font-semibold"
                      >Schedule This Delivery
                    </span>
                  </mat-slide-toggle>
                  <div
                    @showHide
                    *ngIf="this.form.get('isScheduleDelivery')?.value"
                    class="row md:w-[296px] w-full sm:w-full mb-[-10px]"
                  >
                    <mat-form-field appearance="fill">
                      <input
                        formControlName="scheduleDelivery"
                        [min]="this.currentTime"
                        matInput
                        readonly
                        (click)="$event.stopPropagation(); tSaleEndDate.open()"
                        [ngxMatDatetimePicker]="tSaleEndDate"
                      />
                      <button
                        mat-icon-button
                        matRipple
                        (click)="$event.stopPropagation(); tSaleEndDate.open()"
                      >
                        <img
                          matIconSuffix
                          class="w-6 aspect-square"
                          src="assets/images/icons/dateTimePicker.png"
                        />
                      </button>
                      <ngx-mat-datetime-picker
                        #tSaleEndDate
                        [showSpinners]="true"
                        [showSeconds]="false"
                        [enableMeridian]="true"
                      >
                      </ngx-mat-datetime-picker>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Select Delivery Method -->
                <div @showHide>
                  <label
                    class="text-[20px] font-semibold text-blue-theme-color !mb-4 block"
                    >Select Delivery Method</label
                  >
                  <div class="row mb-2">
                    <div
                      class="grid 2xl:grid-cols-4 xl:grid-cols-3 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                    >
                      <ng-container
                        *ngFor="
                          let item of this.isDropoffAdded
                            ? this.deliveryMethodsFire
                            : this.deliveryMethods;
                          let i = index
                        "
                      >
                        <div
                          matRipple
                          (click)="
                            item?.isUnavailable
                              ? null
                              : onSelectdeliveryMethods(i)
                          "
                          [ngClass]="[
                            item.isSelected
                              ? 'border-orange-color bg-orange-color/5'
                              : 'border-[#D8DFE7] bg-transparent',
                            i === this.deliveryMethods.length - 1 &&
                            this.deliveryMethods.length % 2 !== 0
                              ? 'col-span-2 md:col-span-1'
                              : ''
                          ]"
                          class="relative delivery-method-card flex flex-col justify-between border rounded-xl p-2 sm:p-4 min-h-[180px] w-full cursor-pointer transition-all"
                        >
                          <div class="flex justify-between items-start">
                            <!-- Title -->
                            <div
                              class="font-bold text-[14px] sm:text-lg text-blue-theme-color mb-1"
                            >
                              {{ item.title }}
                            </div>
                            <!-- Top-right corner tags and checkmark -->
                            <div
                              class="absolute top-[56px] md:top-3 right-[10px] md:right-3 flex flex-col items-end gap-1 z-10"
                            >
                              <ng-container *ngIf="item.isRecommended">
                                <span class="tag tag-recommended text-nowrap"
                                  >Recommended</span
                                >
                              </ng-container>
                              <ng-container *ngIf="item?.isUnavailable">
                                <span class="tag tag-not-available text-nowrap"
                                  >Not available</span
                                >
                              </ng-container>
                              <img
                                *ngIf="item.isSelected"
                                class="w-6 h-6"
                                src="assets/images/icons/checkMark.svg"
                                alt="Selected"
                              />
                            </div>
                          </div>

                          <!-- Price Row -->

                          <div class="flex items-center gap-2 mb-1">
                            <span
                              class="text-orange-color font-bold text-[12px] sm:text-sm"
                            >
                              {{ item.currency }} {{ item.grossTotal }}
                            </span>
                            <span
                              *ngIf="item.totalCharges > item.grossTotal"
                              class="text-dark-gray text-[13px] sm:text-base line-through"
                            >
                              {{ item.currency }} {{ item.totalCharges }}
                            </span>
                          </div>

                          <!-- Estimated Time -->
                          <div
                            class="text-blue-500 text-[12px] sm:text-sm font-semibold mb-2"
                          >
                            {{ item.estimateTime }}
                          </div>

                          <!-- Illustration/Image -->
                          <div class="flex justify-end items-end flex-1">
                            <img
                              [src]="item.icon"
                              class="w-[60px] sm:w-24 sm:h-16 object-contain"
                              alt="{{ item.title }}"
                              style="max-width: 100px; max-height: 70px"
                            />
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <ng-container
                  *ngIf="
                    (this.isBusinessPartner &&
                      this.orderDoc?.paymentMethod?.length) ||
                    !this.isBusinessPartner
                  "
                >
                  <!-- payment Methods Start -->
                  <div>
                    <label
                      class="text-[20px] font-semibold text-blue-theme-color !mb-4 block"
                      >Payment Method</label
                    >
                    <div class="row mb-2">
                      <div
                        class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 md:gap-5 sm:gap-3 gap-2"
                      >
                        <ng-container
                          *ngFor="
                            let item of this.paymentMethods;
                            let i = index
                          "
                        >
                          <!-- {{ item | json }} -->

                          <div
                            matRipple
                            (click)="onSelectPaymentMethod(item.id)"
                            [ngClass]="
                              item.isSelected
                                ? 'border-orange-color bg-orange-color/5'
                                : 'border-[#D8DFE7] bg-transparent '
                            "
                            class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative flex cursor-pointer border items-center bg-transparent rounded-lg gap-3"
                          >
                            <!-- <div *ngIf="i == 3 ? item.addIsRecommended && this.selectedDeliveryMethod ? this.selectedDeliveryMethod?.pdasWalletAmount < 0  : true : item.isRecommended" class="absolute font-light bottom-0 z-10 right-0 bg-green-color text-white-color text-xs leading-[14px] px-2 py-[0px]" style="border-top-left-radius: 8px;">Recommended</div> -->
                            <div
                              *ngIf="
                                i == 3
                                  ? this.selectedDeliveryMethod
                                      ?.pdasWalletAmount < 0 &&
                                    item.isRecommended
                                    ? true
                                    : false
                                  : item.isRecommended
                              "
                              class="absolute font-light bottom-0 z-10 right-1 tag tag-recommended !rounded-b-none text-white-color !mb-0 !text-[10px] px-2 !py-[0px]"
                              style="border-top-left-radius: 8px"
                            >
                              Recommended
                            </div>
                            <img
                              draggable="false"
                              [src]="
                                item.isSelected ? item.selectedIcon : item.icon
                              "
                              class="w-[40px] aspect-square"
                              alt=""
                            />
                            <div class="flex-1">
                              <span
                                class="text-base text-blue-theme-color font-semibold"
                                >{{ item.title | titlecase }}</span
                              >
                              <div
                                class="flex justify-between"
                                *ngIf="item.id == 4"
                              >
                                <p
                                  class="text-base font-bold text-orange-color"
                                >
                                  {{ this.selectedDeliveryMethod?.currency }}
                                  {{
                                    this.selectedDeliveryMethod
                                      ?.pdasWalletAmount
                                  }}
                                </p>
                              </div>
                            </div>
                            <img
                              *ngIf="item.isSelected"
                              class="absolute w-5 aspect-square top-2 right-2"
                              src="assets/images/icons/checkMark.svg"
                              alt=""
                            />
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <!-- payment Methods End -->

                  <!-- Promo Code Start -->
                  <div>
                    <mat-slide-toggle
                      formControlName="isPromoApplied"
                      (change)="onPromoToggle($event)"
                      ><span
                        class="sm:text-lg text-base text-blue-theme-color font-semibold"
                        >Apply Promo Code</span
                      ></mat-slide-toggle
                    >
                    <div class="row md:w-[296px] w-full sm:w-full mb-2">
                      <mat-form-field
                        *ngIf="this.form.get('isPromoApplied').value"
                        appearance="fill"
                      >
                        <input
                          [readonly]="true"
                          matInput
                          formControlName="promoTitle"
                          class="uppercase"
                        />
                        <button
                          *ngIf="this.form.get('promoTitle').value"
                          (click)="removePromoCode()"
                          mat-icon-button
                        >
                          <mat-icon class="material-icons text-orange-color"
                            >cancel</mat-icon
                          >
                        </button>
                        <mat-error
                          *ngIf="
                            this.form.get('promoTitle').hasError('inValid')
                          "
                          >Invaild promo code.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Promo Code End -->

                  <!-- phlenu case -->
                  <!-- <div
                    *ngIf="
                      this.selectedDeliveryMethod?.walletAmt > 1 &&
                      this.selectedDeliveryMethod &&
                      !this.isBusinessPartner
                    "
                  >
                    <mat-checkbox
                      formControlName="isPhlenuCashApplied"
                      (click)="onPhlenuCash()"
                      class="flex items-center checkWithIcon"
                    >
                      <span class="text-[18px] font-semibold text-blue"
                        >Apply phlenu cash ({{
                          this.selectedDeliveryMethod.currency
                        }}
                        {{ this.selectedDeliveryMethod.walletAmt }})</span
                      >
                    </mat-checkbox>
                  </div> -->
                </ng-container>
              </div>
            </ng-template>
          </form>
        </div>
        <aside *ngIf="shouldShowPaymentSummary" class="lg:hidden block">
          <div class="pt-6 summary-content">
            <div class="overflow-y-auto px-4">
              <ng-container
                *ngTemplateOutlet="paymentSummaryTemplate"
              ></ng-container>
            </div>

            <div
              class="w-full my-4 px-4"
              *ngIf="
                this.selectedDeliveryMethod &&
                this.selectedDeliveryMethod.walletAmt > 0 &&
                !this.isBusinessPartner
              "
            >
              <mat-slide-toggle
                [formControl]="form.get('isPhlenuCashApplied')"
                (change)="onPhlenuCash()"
                class="w-full flex items-center justify-between"
              >
                <span
                  class="text-blue-theme-color font-semibold !text-sm sm:!text-base"
                >
                  Apply Phlenu Cash ({{
                    this.selectedDeliveryMethod?.currency
                  }}
                  {{ this.selectedDeliveryMethod?.walletAmt || 0 }})
                </span>
              </mat-slide-toggle>
            </div>

            <div class="px-4 my-8">
              <button
                mat-flat-button
                color="primary"
                class="w-full text-white-color rounded-lg bg-blue-theme-color !h-12"
                [disabled]="this.isConfirmingOrder"
                (click)="onConfirm()"
              >
                <span *ngIf="!this.isConfirmingOrder">Confirm Order</span>
                <mat-progress-spinner
                  class="custom-spinner text-white-color mx-auto"
                  *ngIf="this.isConfirmingOrder"
                  [diameter]="24"
                  [mode]="'indeterminate'"
                ></mat-progress-spinner>
              </button>
            </div>
          </div>
        </aside>
      </div>

      <!-- Responsive Aside: Payment Summary -->
      <aside *ngIf="shouldShowPaymentSummary" class="summary-aside">
        <div class="pt-6 summary-content">
          <div class="overflow-y-auto px-4">
            <ng-container
              *ngTemplateOutlet="paymentSummaryTemplate"
            ></ng-container>
          </div>

          <div
            class="w-full my-4 px-4"
            *ngIf="
              this.selectedDeliveryMethod &&
              this.selectedDeliveryMethod.walletAmt > 0 &&
              !this.isBusinessPartner
            "
          >
            <mat-slide-toggle
              [formControl]="form.get('isPhlenuCashApplied')"
              (change)="onPhlenuCash()"
              class="w-full flex items-center justify-between"
            >
              <span
                class="text-blue-theme-color font-semibold !text-sm sm:!text-base"
              >
                Apply Phlenu Cash ({{ this.selectedDeliveryMethod?.currency }}
                {{ this.selectedDeliveryMethod?.walletAmt || 0 }})
              </span>
            </mat-slide-toggle>
          </div>

          <div class="px-4 my-8">
            <button
              mat-flat-button
              color="primary"
              class="w-full text-white-color rounded-lg bg-blue-theme-color !h-12"
              [disabled]="this.isConfirmingOrder"
              (click)="onConfirm()"
            >
              <span *ngIf="!this.isConfirmingOrder">Confirm Order</span>
              <mat-progress-spinner
                class="custom-spinner text-white-color mx-auto"
                *ngIf="this.isConfirmingOrder"
                [diameter]="24"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
            </button>
          </div>
        </div>
      </aside>
    </div>
  </mat-drawer-content>

  <mat-drawer
    #pickupDrawer
    mode="over"
    class="w-[350px] relative"
    position="end"
  >
    <app-pickup-locations-dialog
      [heading]="'Recent Pickup Locations'"
      [isPickup]="1"
      [selected]="form.get('pickupLocation').value"
      (close)="onPickupDrawerClose()"
      (locationSelected)="onPickupLocationSelected($event)"
    ></app-pickup-locations-dialog>
  </mat-drawer>

  <!-- Payment Summary Template -->
  <ng-template #paymentSummaryTemplate>
    <ul class="">
      <li class="flex w-full py-2">
        <div class="flex flex-col w-full">
          <span
            class="bill-label text-sm sm:text-base md:text-lg text-blue-theme-color font-semibold mb-[15px]"
            >Payment Summary</span
          >
          <div
            class="flex flex-col w-full shadow-sm border border-[#D8DFE7] rounded-lg"
          >
            <ng-container
              *ngFor="
                let dropoff of this.selectedDeliveryMethod?.dropPoint;
                let dropIndex = index
              "
            >
              <!-- Route Card Design -->
              <div class="route-card bg-white p-4">
                <!-- Header with title and numbers -->
                <div class="flex justify-between items-start mb-3 pb-4">
                  <div class="flex items-center gap-2">
                    <span
                      class="text-sm sm:text-base text-black-color font-semibold capitalize"
                    >
                      <!-- Shimmer for dropoff name -->
                      <div
                        *ngIf="shouldShowPaymentSummaryShimmer()"
                        class="h-4 bg-gray-color rounded animate-pulse w-24"
                      ></div>
                      <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                        {{ dropoff?.name || "Drop-off " + (dropIndex + 1) }}
                        <span
                          *ngIf="dropoff?.isPhlenuTrustCheckApplied"
                          class="inline-flex items-center bg-[#ddf5db] text-green-color text-[10px] font-medium ml-1 px-2 rounded-full"
                          >🛡️ Verified</span
                        >
                      </span>
                    </span>
                  </div>
                  <div class="flex gap-2">
                    <s
                      *ngIf="!this.isBusinessPartner"
                      class="text-sm font-bold text-gray-700"
                    >
                      <mat-progress-spinner
                        *ngIf="shouldShowPaymentSummaryShimmer()"
                        class="data-spinner text-dark-gray"
                        [diameter]="16"
                        [mode]="'indeterminate'"
                      ></mat-progress-spinner>
                      <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                        {{ getAmountDisplay(dropoff.charges) }}
                      </span>
                    </s>
                    <span class="text-sm font-bold text-blue-theme-color">
                      <mat-progress-spinner
                        *ngIf="shouldShowPaymentSummaryShimmer()"
                        class="data-spinner text-blue-theme-color"
                        [diameter]="16"
                        [mode]="'indeterminate'"
                      ></mat-progress-spinner>
                      <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                        {{ getAmountDisplay(dropoff.payToCustomer) }}
                      </span>
                    </span>
                  </div>
                </div>

                <!-- Route Line with Pickup and Delivery -->
                <div class="route-line-container pt-4 relative">
                  <!-- Horizontal route line -->
                  <div
                    class="route-line w-full h-0.5 bg-gray-300 relative"
                  ></div>

                  <!-- Pickup Location (Left) -->
                  <div
                    class="pickup-location absolute left-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                  >
                    <mat-icon
                      class="text-white-color rounded-full bg-orange-color text-sm"
                      >location_on</mat-icon
                    >
                    <span class="text-xs text-gray-600 font-medium mt-1"
                      >Pickup</span
                    >
                  </div>

                  <!-- Distance in center -->
                  <div
                    class="distance-indicator absolute left-1/2 top-[-10px] transform -translate-x-1/2 -translate-y-1/2 bg-[#E3F2FD] px-2"
                  >
                    <span class="text-xs text-[#387DF4] font-semibold">
                      {{ dropoff?.distance || 0 }} KM
                    </span>
                  </div>

                  <!-- Delivery Location (Right) -->
                  <div
                    class="delivery-location absolute right-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                  >
                    <mat-icon
                      class="text-white-color rounded-full bg-blue-theme-color text-sm"
                      >location_on</mat-icon
                    >
                    <span class="text-xs text-gray-600 font-medium mt-1"
                      >Delivery</span
                    >
                  </div>
                </div>

                <!-- Address below route -->
                <div class="mt-3">
                  <span
                    *ngIf="dropoff?.address"
                    class="text-xs text-gray-500 line-clamp-2"
                  >
                    <!-- Shimmer for address -->
                    <div
                      *ngIf="shouldShowPaymentSummaryShimmer()"
                      class="h-3 bg-gray-color rounded animate-pulse w-32"
                    ></div>
                    <!-- <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                      {{ dropoff?.address }}
                    </span> -->
                  </span>
                </div>
              </div>

              <span
                class="px-2"
                *ngIf="
                  dropIndex !==
                  this.selectedDeliveryMethod?.dropPoint.length - 1
                "
                ><mat-divider> </mat-divider
              ></span>
            </ng-container>

            <!-- Empty state shimmer when no dropoff points -->
            <div
              *ngIf="
                shouldShowPaymentSummaryShimmer() &&
                (!this.selectedDeliveryMethod?.dropPoint ||
                  this.selectedDeliveryMethod?.dropPoint.length === 0)
              "
              class="route-card bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
            >
              <div class="flex justify-between items-start mb-3">
                <div class="flex items-center gap-2">
                  <div
                    class="h-4 bg-gray-color rounded animate-pulse w-24"
                  ></div>
                  <div
                    class="h-6 bg-gray-color rounded-full animate-pulse w-16"
                  ></div>
                </div>
                <div class="flex gap-2">
                  <div
                    class="h-4 bg-gray-color rounded animate-pulse w-8"
                  ></div>
                  <div
                    class="h-4 bg-gray-color rounded animate-pulse w-8"
                  ></div>
                </div>
              </div>
              <div class="route-line-container relative">
                <div class="route-line w-full h-0.5 bg-gray-300 relative"></div>
                <div
                  class="absolute left-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                >
                  <div
                    class="h-6 w-6 bg-gray-color rounded animate-pulse"
                  ></div>
                  <div
                    class="h-3 bg-gray-color rounded animate-pulse w-12 mt-1"
                  ></div>
                </div>
                <div
                  class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white px-2"
                >
                  <div
                    class="h-3 bg-gray-color rounded animate-pulse w-12"
                  ></div>
                </div>
                <div
                  class="absolute right-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                >
                  <div
                    class="h-6 w-6 bg-gray-color rounded animate-pulse"
                  ></div>
                  <div
                    class="h-3 bg-gray-color rounded animate-pulse w-16 mt-1"
                  ></div>
                </div>
              </div>
              <div class="mt-3">
                <div class="h-3 bg-gray-color rounded animate-pulse w-32"></div>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- <mat-divider> </mat-divider> -->
      <div class="flex flex-col gap-[8px] py-[4px]">
        <li class="flex justify-between">
          <span class="bill-label !text-[14px] text-black-color">{{
            !this.isBusinessPartner ? "Total Before Discount" : "Total"
          }}</span>
          <span
            class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="shouldShowPaymentSummaryShimmer()"
              class="data-spinner text-blue-theme-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span *ngIf="!shouldShowPaymentSummaryShimmer()">
              {{ this.selectedDeliveryMethod?.currency }}
              {{ getAmountDisplay(this.selectedDeliveryMethod?.totalCharges) }}
            </span>
          </span>
        </li>
        <li
          *ngIf="
            this.selectedDeliveryMethod?.promoResponse?.promoDiscountAmount > 0
          "
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color"
            >(-) Promotion</span
          >
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="shouldShowPaymentSummaryShimmer()"
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span *ngIf="!shouldShowPaymentSummaryShimmer()">
              {{
                getAmountDisplay(
                  this.selectedDeliveryMethod?.promoResponse
                    ?.promoDiscountAmount
                )
              }}
            </span>
          </span>
        </li>
        <li
          *ngIf="this.selectedDeliveryMethod?.discountAmount > 0"
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color">
            (-)Discount ({{
              this.selectedDeliveryMethod?.discountinpercentage || 0
            }}%)
          </span>
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="shouldShowPaymentSummaryShimmer()"
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span *ngIf="!shouldShowPaymentSummaryShimmer()">
              {{
                getAmountDisplay(this.selectedDeliveryMethod?.discountAmount)
              }}
            </span>
          </span>
        </li>

        <li
          *ngIf="this.selectedDeliveryMethod?.loadingFee > 0"
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color">
            (+) Loading Fee</span
          >
          <span
            class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="shouldShowPaymentSummaryShimmer()"
              class="data-spinner text-blue-theme-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span *ngIf="!shouldShowPaymentSummaryShimmer()">
              {{ getAmountDisplay(this.selectedDeliveryMethod?.loadingFee) }}
            </span>
          </span>
        </li>
        <li
          *ngIf="this.orderDoc?.isPhlenuCashApplied"
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color"
            >(-) Phlenu Cash</span
          >
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="shouldShowPaymentSummaryShimmer()"
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span *ngIf="!shouldShowPaymentSummaryShimmer()">
              {{
                getAmountDisplay(this.selectedDeliveryMethod?.phlenuCashAmount)
              }}
            </span>
          </span>
        </li>
        <li
          *ngIf="this.orderDoc?.isPdasWalletApplied"
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color"
            >(-) Wallet Used</span
          >
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="shouldShowPaymentSummaryShimmer()"
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span *ngIf="!shouldShowPaymentSummaryShimmer()">
              {{
                getAmountDisplay(
                  this.selectedDeliveryMethod?.pdasWalletUsedAmount
                )
              }}
            </span>
          </span>
        </li>
      </div>
    </ul>

    <mat-divider></mat-divider>
    <div class="flex flex-col gap-[8px] py-[4px]">
      <div
        *ngIf="
          this.selectedDeliveryMethod?.grossTotal > 0 && !this.isBusinessPartner
        "
        class="flex justify-between"
      >
        <span class="bill-label !text-sm text-black-color"
          >Discounted Amount</span
        >
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >
          <mat-progress-spinner
            *ngIf="shouldShowPaymentSummaryShimmer()"
            class="data-spinner text-blue-theme-color"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <span *ngIf="!shouldShowPaymentSummaryShimmer()">
            {{ getAmountDisplay(this.selectedDeliveryMethod?.grossTotal) }}
          </span>
        </span>
      </div>

      <div
        class="flex justify-between items-center"
        *ngIf="getIsTrustCheckApplied()"
      >
        <div class="flex items-center gap-1">
          <span class="text-[14px] text-black-color">Phlenu TrustCheck</span>

          <mat-icon
            matTooltipClass="custom-tooltip"
            [matTooltip]="trustCheckTooltip"
            matTooltipPosition="above"
            class="text-dark-gray cursor-pointer text-[12px]"
            >info_outline</mat-icon
          >
        </div>

        <span class="text-[16px] text-blue-theme-color font-semibold">
          <mat-progress-spinner
            *ngIf="shouldShowPaymentSummaryShimmer()"
            class="data-spinner text-blue-theme-color"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <span *ngIf="!shouldShowPaymentSummaryShimmer()">
            {{
              getAmountDisplay(
                this.orderDoc?.deliveryCharges[0]
                  ?.totalPhlenuTrustCheckCommisionApplied
              )
            }}
          </span>
        </span>
      </div>
    </div>
    <mat-divider
      *ngIf="
        this.selectedDeliveryMethod?.grossTotal > 0 && !this.isBusinessPartner
      "
    ></mat-divider>
    <div class="flex justify-between py-2">
      <span
        class="bill-label !text-sm sm:!text-lg text-orange-color font-semibold"
        >Delivery Charge</span
      >
      <span
        class="bill-value flex justify-end gap-2 !text-sm sm:!text-lg text-orange-color font-medium"
      >
        <mat-progress-spinner
          *ngIf="shouldShowPaymentSummaryShimmer()"
          class="data-spinner text-orange-color"
          [diameter]="20"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
        <span *ngIf="!shouldShowPaymentSummaryShimmer()">
          {{ this.selectedDeliveryMethod?.currency }}
          {{ getAmountDisplay(this.selectedDeliveryMethod?.netTotal) }}
        </span>
      </span>
    </div>

    <mat-divider></mat-divider>

    <div
      class="flex flex-col pt-2"
      *ngIf="this.isTotalCashCollection() && this.selectedDeliveryMethod"
    >
      <li class="flex justify-between">
        <span class="bill-label !text-[14px] text-black-color"
          >Cash collection</span
        >
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >
          <mat-progress-spinner
            class="data-spinner text-blue-theme-color"
            *ngIf="isDataLoading; else dataVisible"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <ng-template #dataVisible>
            <span
              class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
              >{{ this.selectedDeliveryMethod?.currency }}
              <mat-progress-spinner
                *ngIf="shouldShowPaymentSummaryShimmer()"
                class="data-spinner text-blue-theme-color"
                [diameter]="20"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
              <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                {{ getAmountDisplay(this.getTotalCashCollection()) }}
              </span></span
            >
          </ng-template>
        </span>
      </li>

      <li class="flex justify-between">
        <span class="bill-label !text-[14px] text-black-color"
          >Cash collection Fee
        </span>
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >
          <mat-progress-spinner
            class="data-spinner text-blue-theme-color"
            *ngIf="isDataLoading; else collectiondataVisible"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <ng-template #collectiondataVisible>
            <span
              class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
              >{{ this.selectedDeliveryMethod?.currency }}
              <mat-progress-spinner
                *ngIf="shouldShowPaymentSummaryShimmer()"
                class="data-spinner text-blue-theme-color"
                [diameter]="20"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
              <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                {{
                  getAmountDisplay(
                    this.selectedDeliveryMethod?.feeOnCashCollect
                  )
                }}
              </span></span
            >
          </ng-template>
        </span>
      </li>
    </div>

    <!-- Estimated time -->
    <div
      *ngIf="this.selectedDeliveryMethod?.estimateTime && !this.isPharmacyOrder"
      class="flex justify-between pt-2"
    >
      <span
        class="bill-label !text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >Estimated time</span
      >
      <mat-progress-spinner
        class="data-spinner text-blue-theme-color"
        *ngIf="isDataLoading; else dataVisible"
        [diameter]="20"
        [mode]="'indeterminate'"
      ></mat-progress-spinner>
      <ng-template #dataVisible>
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
          >{{ this.selectedDeliveryMethod?.estimateTime }}</span
        >
      </ng-template>
    </div>
  </ng-template>
</mat-drawer-container>
